module.exports = __webpack_public_path__ + "static/media/S_A.d7772a70.png";